<p>component-base works!</p>
